var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.999,
    height: 19.999,
    viewBox: "0 0 19.999 19.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39677",
    "data-name": "Path 39677",
    d: "M20,10A10,10,0,1,1,10,0,10,10,0,0,1,20,10",
    transform: "translate(161 616)",
    fill: "#ebebeb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile_placeholder",
    transform: "translate(-161 -616)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26217",
    "data-name": "Group 26217",
    transform: "translate(161 616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39675",
    "data-name": "Path 39675",
    d: "M20,10A10,10,0,1,1,10,0,10,10,0,0,1,20,10",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39676",
    "data-name": "Path 39676",
    d: "M9.685,26.272s1.21-.559,1.83-.822a10.342,10.342,0,0,0,2.7-1.3,2.059,2.059,0,0,0,.822-1.846c.015-.636-.128-.488-.6-1.193-.388-.582-.178-1.18-.682-1.467a1.02,1.02,0,0,1-.512-.931c-.047-.737.3-.977.3-.977s-.217-1.28-.217-1.7A2.94,2.94,0,0,1,14.68,13.6a4.736,4.736,0,0,1,4.716.171c1.07.931,1.334,1.815.869,3.91a1.027,1.027,0,0,1,.31,1.024,2.326,2.326,0,0,1-.194.7c-.132.206-.574.222-.636.61a2.67,2.67,0,0,1-.551,1.357c-.38.45-.4.473-.4.745a2.352,2.352,0,0,0,.954,2.133,7.207,7.207,0,0,0,1.768.884,17.154,17.154,0,0,1,2.594,1.14v3.4H9.685Z",
    transform: "translate(-6.918 -9.324)",
    fill: "#3a4b55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPhoto);
export default __webpack_public_path__ + "static/media/user-photo.a7c5b60e23965964e6135d67fff2e4f6.svg";
export { ForwardRef as ReactComponent };